/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AdminGetCurrentAdminUserInfoDataDto
 */
export interface AdminGetCurrentAdminUserInfoDataDto {
    /**
     * 어드민 유저 uuid
     * @type {string}
     * @memberof AdminGetCurrentAdminUserInfoDataDto
     */
    'adminUserUuid': string;
    /**
     * 아이디
     * @type {string}
     * @memberof AdminGetCurrentAdminUserInfoDataDto
     */
    'id': string;
    /**
     * 이름
     * @type {string}
     * @memberof AdminGetCurrentAdminUserInfoDataDto
     */
    'name': string;
    /**
     * 등급
     * @type {string}
     * @memberof AdminGetCurrentAdminUserInfoDataDto
     */
    'rank': AdminGetCurrentAdminUserInfoDataDtoRankEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminGetCurrentAdminUserInfoDataDto
     */
    'permissions': Array<AdminGetCurrentAdminUserInfoDataDtoPermissionsEnum>;
}

export const AdminGetCurrentAdminUserInfoDataDtoRankEnum = {
    Normal: 'normal',
    Master: 'master'
} as const;

export type AdminGetCurrentAdminUserInfoDataDtoRankEnum = typeof AdminGetCurrentAdminUserInfoDataDtoRankEnum[keyof typeof AdminGetCurrentAdminUserInfoDataDtoRankEnum];
export const AdminGetCurrentAdminUserInfoDataDtoPermissionsEnum = {
    Dashboard: 'dashboard',
    Report: 'report',
    AccountManagement: 'accountManagement',
    UserManagement: 'userManagement',
    ExchangeManagement: 'exchangeManagement',
    OperationManagement: 'operationManagement'
} as const;

export type AdminGetCurrentAdminUserInfoDataDtoPermissionsEnum = typeof AdminGetCurrentAdminUserInfoDataDtoPermissionsEnum[keyof typeof AdminGetCurrentAdminUserInfoDataDtoPermissionsEnum];


